export default "__VITE_ASSET__CzGj9kkM__"